


































import { Component, Vue } from 'vue-property-decorator'
import authModule from '@/store/auth'
import eventModule from '@/store/event'

@Component({
  name: 'ActivationBanner'
})
export default class ActivationBanner extends Vue {
  private async refreshProfile() {
    await authModule.fetchUser()
    if (authModule.user!.confirmed) {
      this.$router.push({ name: 'HomeView' })
    } else {
      eventModule.newInfo(
        'Bitte klicke auf den Link auf deiner Bestätigungs-Email, um deinen Account zu aktivieren. Vielen Dank!'
      )
    }
  }
}
